import { useCallback, useEffect, useState } from 'react';

const FLASH_DURATION = 300;

function useFlashEffect(duration = FLASH_DURATION) {
  const [isFlashing, setIsFlashing] = useState(false);

  const triggerFlash = useCallback(() => setIsFlashing(true), []);

  useEffect(() => {
    if (isFlashing) {
      const timer = setTimeout(() => setIsFlashing(false), duration);
      return () => clearTimeout(timer);
    }
  }, [isFlashing, duration]);

  return { isFlashing, triggerFlash };
}

export { useFlashEffect };
